export function eq(left: Array<string>, right: Array<string>): boolean {
    return left.length === right.length && left.every(str => right.includes(str));
}
